import { Link } from 'react-router-dom';
import { useI18n, type MessageKey } from '@/i18n';

const FOOTER_LINKS: Array<{ to: string; key: MessageKey }> = [
  { to: '/library?category=live', key: 'category.live' },
  { to: '/library?category=slot', key: 'category.slot' },
  { to: '/roadmap', key: 'nav.roadmap' },
  { to: '/assets', key: 'nav.assets' },
];

const SITE_URL = 'https://richyplay.live';

export function SiteFooter() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner site-pad-x">
        <div className="site-footer__brand">
          <Link to="/" className="site-footer__logo" aria-label={t('nav.brandAria')}>
            <img src="/brand/richyplay-logo.png" alt="RichyPlay" width={180} height={32} />
          </Link>
          <p className="site-footer__tagline">{t('footer.tagline')}</p>
        </div>

        <nav className="site-footer__nav glass-panel-soft" aria-label={t('footer.navAria')}>
          {FOOTER_LINKS.map((link) => (
            <Link key={link.to} to={link.to} className="site-footer__link">
              {t(link.key)}
            </Link>
          ))}
          <a
            className="site-footer__link site-footer__link--site"
            href={SITE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            richyplay.live
          </a>
        </nav>
      </div>

      <div className="site-footer__legal">
        <div className="site-footer__legal-inner site-pad-x">
          <p>
            © {year} RichyPlay. {t('footer.rights')}
          </p>
          <p>{t('footer.legal')}</p>
        </div>
      </div>
    </footer>
  );
}
